import {Directive, ElementRef, Input, input, Renderer2} from '@angular/core';

@Directive({
	selector: '[dcElementFocus]',
	standalone: true,
})
export class ElementFocusDirective {
	readonly spacialLoaderClass = input('bg-opacity-50');

	/* -------------------------------------------------------------------------- */
	/*                                    Blink                                   */

	/* -------------------------------------------------------------------------- */

	// TODO: Skipped for migration because:
	private actives: Set<string> = new Set<string>();

	/* -------------------------------------------------------------------------- */
	/*                                   Loader                                   */

	/* -------------------------------------------------------------------------- */

	// TODO: Skipped for migration because:

	constructor(
		private element: ElementRef,
		private renderer: Renderer2,
	) {}

	//  Accessor inputs cannot be migrated as they are too complex.
	@Input() set blink(on: boolean) {
		const fullBlinkClass = 'block h-full w-full animate-pulse rounded-md border-2 border-blue-800';
		const blinkClasses = fullBlinkClass.split(' ');
		if (on) {
			blinkClasses.forEach(c => {
				this.renderer.addClass(this.element.nativeElement, c);
			});
			this.actives.add('blink');
		} else if (this.actives.has('blink')) {
			blinkClasses.forEach(c => {
				this.renderer.removeClass(this.element.nativeElement, c);
			});
			this.actives.delete('blink');
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                                   Spinner                                  */
	/* -------------------------------------------------------------------------- */

	//spinner that works above specific element
	// TODO: Skipped for migration because:

	//  Accessor inputs cannot be migrated as they are too complex.
	@Input() set loader(props: boolean | [on: boolean, loaderClass: string]) {
		const on = typeof props === 'boolean' ? props : props[0];
		const loaderClass = typeof props === 'boolean' ? undefined : props[1];

		if (on) {
			let outerClasses = 'table-loader absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-white bg-opacity-50 z-10 pointer-cw-events-none'.split(' ');
			const customLoaderClasses = loaderClass?.split(' ');
			if (customLoaderClasses) outerClasses = outerClasses.concat(customLoaderClasses);
			const loader = this.renderer.createElement('div');
			outerClasses?.forEach(c => {
				loader.classList.add(c);
			});
			loader.innerHTML = `<i class="animate-spin fa-duotone fa-spinner-third text-blue-500 fa-3x"></i>`;
			this.renderer.insertBefore((this.element.nativeElement as HTMLElement).parentElement, loader, this.element.nativeElement);
			this.actives.add('loader');
		} else if (this.actives.has('loader') && on == false) {
			this.renderer.removeChild((this.element.nativeElement as HTMLElement).parentElement, (this.element.nativeElement as HTMLElement).parentElement.querySelector('.table-loader'));
			this.actives.delete('loader');
		}
	}

	//  Accessor inputs cannot be migrated as they are too complex.
	@Input() set spinner(on: boolean) {
		if (on) {
			const outerClasses = 'spinner absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-white bg-opacity-50 z-10 pointer-cw-events-none'.split(' ');
			const loader = this.renderer.createElement('div');
			outerClasses?.forEach(c => {
				loader.classList.add(c);
			});
			loader.innerHTML = `<i class="animate-spin fa-duotone fa-spinner-third text-blue-500 fa-3x"></i>`;
			this.renderer.insertBefore((this.element.nativeElement as HTMLElement).parentElement, loader, this.element.nativeElement);
			this.actives.add('spinner');
		} else if (this.actives.has('spinner') && on == false) {
			this.renderer.removeChild((this.element.nativeElement as HTMLElement).parentElement, (this.element.nativeElement as HTMLElement).parentElement.querySelector('.spinner'));
			this.actives.delete('spinner');
		}
	}

	/* -------------------------------------------------------------------------- */
	/*                                   Methods                                  */
	/* -------------------------------------------------------------------------- */
}
